import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./slices/loginSlice";
import permissionReducer from "./slices/permissionSlice";
import { ThunkDispatch } from "redux-thunk";
import authReducer from "./slices/authSlice";

export const store = configureStore({
  reducer: {
    login: loginReducer,
    permission: permissionReducer,
    auth: authReducer,
  },
});
// Infer the `RootState` and `AppDispatch` types
/* eslint-disable  @typescript-eslint/no-explicit-any */
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunkDispatch = ThunkDispatch<RootState, unknown, any>;
/* eslint-disable  @typescript-eslint/no-explicit-any */
